import React from 'react'
import { Col, Modal, ModalBody, Row,ModalFooter,Button,ModalHeader} from 'reactstrap';
import 'animate.css';



export const ModalPreviewInvoiceGlobal = (props) => {
    
    const { loadingPreviewInvoices, showPreviewInvoicesGlobal, handlePreviewGlobalInvoices,handleCancelGlobal,saveInvoicesGlobal,loadingGlobal } = props;

    return (
        <Modal isOpen={showPreviewInvoicesGlobal} toggle={handlePreviewGlobalInvoices} centered={true} size={loadingPreviewInvoices ? 'sm' : 'lg'} scrollable={true}>
             {!loadingPreviewInvoices &&<ModalHeader className='bg-danger'>
               Factura Global
            </ModalHeader>}
            <ModalBody>
                {
                    loadingPreviewInvoices && (
                        <>
                            <Row>
                                <Col sm="12" md="12" lg="12" className='text-center'>
                                    <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "20%" }} />
                                </Col>
                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                    <p>Cargando ...</p>
                                </Col>
                            </Row>
                        </>
                    )
                }
                {!loadingPreviewInvoices && <Col sm="12" style={{textAlign:"center"}} className='p-l-0  p-r-0' >
                <img alt='modal-preview' src={require("../../assets/images/price/warnig-invoices.svg")}style={{ width: "15%" }} /> <br />
                <label className='f-14 f-w-600 txt-danger pt-1' >Esta seguro que estos nims, se facturaran a público general</label>
                </Col>}
            </ModalBody>  
            {!loadingPreviewInvoices &&<ModalFooter>
            <Col sm="12">
            <Row>
                <Col sm="8">
                </Col>
                <Col sm="2" style={{textAlign: "end"}} >
                    <Button disabled={loadingGlobal ? true : false} outline color="primary" onClick={ () => saveInvoicesGlobal()} >Aceptar</Button>
                </Col>
                <Col sm="2">
                    <Button disabled={loadingGlobal ? true : false} outline color="danger" onClick={() => handleCancelGlobal()}   >Cancelar</Button>
                </Col>
            </Row>
            </Col>
            </ModalFooter>}

        </Modal>
            )
        }
